import {
  CUSTOM_FIELD_FETCH_REQUEST,
  CUSTOM_FIELD_FETCH_REQUEST_SUCCESS,
  CUSTOM_FIELD_FETCH_REQUEST_FAILURE,
  CUSTOM_FIELD_ADD_REQUEST,
  CUSTOM_FIELD_ADD_REQUEST_SUCCESS,
  CUSTOM_FIELD_ADD_REQUEST_FAILURE,
  CUSTOM_FIELD_UPDATE_REQUEST,
  CUSTOM_FIELD_UPDATE_REQUEST_SUCCESS,
  CUSTOM_FIELD_UPDATE_REQUEST_FAILURE,
  CUSTOM_FIELD_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const customFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CUSTOM_FIELD_ADD_REQUEST:
    case CUSTOM_FIELD_FETCH_REQUEST:
    case CUSTOM_FIELD_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CUSTOM_FIELD_ADD_REQUEST_SUCCESS:
    case CUSTOM_FIELD_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case CUSTOM_FIELD_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
        },
      });

    case CUSTOM_FIELD_ADD_REQUEST_FAILURE:
    case CUSTOM_FIELD_FETCH_REQUEST_FAILURE:
    case CUSTOM_FIELD_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CUSTOM_FIELD_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
        },
      });

    default:
      return state;
  }
};

export default customFieldsReducer;
